<template>
  <div class="d-flex justify-content-between align-items-center" :class="{active: bool}">
    <span class="d-flex align-items-center flex-grow-1">
      <span class="ske forced-ske photo-ske">
        <span class="radio" @click="$emit('radio-click')">
          <span v-if="bool" class="inner-radio"></span>
        </span>
      </span>
      <span class="name flex-grow-1 ml-1" @click="$emit('content-click')">
        <span class="ske forced-ske">
          <slot></slot>
        </span>
      </span>
    </span>
  </div>
</template>

<script>

export default {
  name: "base-custom-radio",
  props: {
    value: {
      type: Boolean
    },
  },
  data() {
    return {
      bool: this.value || false,
    }
  },
  created() {
    this.$emit("input", this.bool)
  },
  watch: {
    bool(val) {
      this.$emit("input", val)
    },
    value(val) {
      this.bool = val
    },
  },
}

</script>

<style scoped>

.radio {
  width: 10px;
  height: 10px;
  border-radius: 800px;
  padding: 1px;
  border: 1px solid #D1D3D4;
  margin-right: 4px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-radio {
  width: 6px;
  height: 6px;
  border-radius: 500px;
}

.inner-radio {
  background-color: var(--mint-green);
}

.main {
  font-size: 0.9375em;
  color: rgb(37,44,59);
  width: 100%;
}

.name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
